var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZhicheng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.56836 12.8182L14.6593 5.72726",
    stroke: "#2F88FF",
    strokeWidth: 1.18182
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.841 11.6364H1.65918V14H15.841V11.6364Z",
    fill: "#B48357",
    stroke: "#D9D9D9",
    strokeWidth: 0.0271792
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6591 11.6364L14.75 2",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZhicheng);
export default __webpack_public_path__ + "static/media/zhicheng.792c7be33712afb8b2325e079d59e60a.svg";
export { ForwardRef as ReactComponent };